var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp__loader__container loader"},[_c('img',{attrs:{"width":"80px","height":"80px","alt":"Processing...","src":_vm.processingGIF},on:{"error":function($event){return require('@/assets/images/loader.svg')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }